//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import wx from 'weixin-jsapi'

export default {
  name: 'VyDetail',
  components: {},
  props: {
    responseList: {
      type: Object,
      default: function () {
        return {}
      },
    },
    mapping: {
      type: Object,
      default: function () {
        return {}
      },
    },
    textAlignLeft: {
      type: Boolean,
      default: false,
    },
    isDynamic: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      openPanel: true,
    }
  },
  computed: {
    resObj: {
      get () {
        return this.responseList
      },
      set (newValue) {
        this.$emit('update:responseList', newValue)
      },
    },
    mapObj: {
      get () {
        return this.mapping
      },
      set (newValue) {
        this.$emit('update:mapping', newValue)
      },
    },
  },
  watch: {
    // async showMap (newValue) {
    //   if(newValue === true) {
    //     this.initMap()
    //   }
    // },
  },
  mounted () {},
  methods: {
    toggle (mapp) {
      mapp.show = !mapp.show
    },
    isRedFilter (resObj, key) {
      // 1. 针对“在保到期提示”的特殊处理
      // 逻辑：只要 new_expire_remind 有值（上面已判断非空），就标红
      if(key.value === 'new_expire_remind') {
        return true
      }
      if(key.value === 'new_debt_remind') {
        return true
      }
      if(key.value === 'new_receivable_remind') {
        return true
      }
      if(key.value === 'new_follow_remind') {
        return true
      }

      // 如果值为空，通常不标红（除非有特殊需求）
      if(this.isEmpty(resObj[key.value])) {
        return false
      }

      // 2. 参考 VyDetailSmall 的原有逻辑 (处理 IsRed 属性)
      // 如果配置中有 IsRed: true，再进行判断
      if(key.IsRed) {
        if(key.label === '破产预警' || resObj[key.label] === '破产预警') {
          // 破产预警 = 是(100000001) 时 标红显示
          return parseInt(resObj[key.value]) === 100000001
        }
        // 如果只是标记了 IsRed 但不是破产预警，默认标红
        return true
      }
      return false
    },
    // 跳转外部页面
    gotoOutsideUrl (url) {
      if(!this.isEmpty(url)) {
        var u = navigator.userAgent
        // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 是否android终端
        // 判断是否是 iPad，通过匹配 iPad 及其操作系统版本
        var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios
        var VXUserJobNumber = this.getLocalValue('VXUserJobNumber') // 企业微信员工工号
        if(!this.isEmpty(VXUserJobNumber) && !ios) {
          // 表示是非iPhone手机从企业微信进入
          var input = document.createElement('input') // 直接构建input
          input.value = url // 设置内容
          document.body.appendChild(input) // 添加临时实例
          input.select() // 选择实例内容
          document.execCommand('Copy') // 执行复制
          document.body.removeChild(input) // 删除临时实例
          this.$toast.show({
            type: 'text',
            content: '已将链接复制，请手动转到浏览器打开', // 默认为空字符串，不传将不显示文案
            position: 'middle', // 默认为middle，居中显示
          })
        } else {
          try {
          // 在默认浏览器打开
            let obj = {url: url}
            window.ReactNativeWebView.postMessage(JSON.stringify(obj))
          } catch (error) {
            window.open(url)
          }
        }
      }
    },
    getPic (value) {
      return `data:image/png;base64,${value}`
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/crm-ui/VyDetail.vue